<template>
    <section class="calendrier">
        <div class="container">
            <div class="wrap-bloc">
                <div class="un-bloc">
                    <div class="head-wrap">
                        <div class="wrap-year">
                            <a href=""><span class="icon-arrow-right left" @click.prevent="removeYear()"></span></a>
                            <span class="year">{{activeYear}}</span>
                            <a href=""><span class="icon-arrow-right right" @click.prevent="addYear()"></span></a>
                        </div>
                    </div>
                    <div class="wrap-month" v-if="!breakpointDownMd">
                        <div v-for="(item, index) in month"
                             :class="{active: item.number === activeMonth}"
                             class="month">
                            <a href="" v-html="item.label" @click.prevent="changeMonth(item)"></a>
                        </div>
                        <div class="loader-wrap" v-if="loadingMonth">
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <custom-select
                            class="mobile-custom-select"
                            value-field="number"
                            label-field="label"
                            :options="month"
                            v-model="activeMonth"
                            @change="changeMonth(null, true)"
                                   v-if="breakpointDownMd && month !== null"></custom-select>

                </div>
                <div class="un-bloc">
                    <div class="head-wrap">
                        <ul class="filtre-taaf-rnn">
                            <li><a href="" :class="{active: activeFilterSite === ''}"
                                   @click.prevent="filtreSite('')">Toutes</a></li>
                            <li><a href="" :class="{active: activeFilterSite === 'taaf'}"
                                   @click.prevent="filtreSite('taaf')"><span class="pastille taaf"></span>TAAF</a></li>
                            <li><a href="" :class="{active: activeFilterSite === 'rnn'}"
                                   @click.prevent="filtreSite('rnn')"><span class="pastille rnn"></span>Réserve
                                naturelle</a></li>
                        </ul>
                    </div>
                    <div class="wrap-days">
                        <div class="day"
                             v-for="(item, index) in days"
                             :class="dayClasses(item)"
                             @click.prevent="selectDay(item)"
                        >
                            <a href="">{{item.number}}</a>
                        </div>
                        <div class="loader-wrap" v-if="loadingDays">
                            <div class="lds-ring">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="wrap-results">
                <div class="one-item" v-for="(item, index) in result" :class="item.site">
                    <div class="wrap-head-item">
                        <div class="bloc-titre">
                            <div class="site-bar"><span></span></div>
                            <h2 class="titre" v-html="item.title"></h2>
                        </div>
                        <div class="bloc-date">
                            <div>
                                <p class="day">{{item.day}}</p>
                                <p class="month">{{item.month}}</p>
                                <p class="year">{{item.year}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="img-item" :style="'background-image: url('+item.imgUrl+')'"></div>
                    <div class="description rte" v-html="item.excerpt"></div>
                    <div class="wrap-cta"><a :href="item.url" class="btn outline">{{item.urlLabel}}</a></div>

                </div>

                <div class="loader-wrap" v-if="loading">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"
    import {debounce} from "lodash"

    export default {
        mixins: [Ajax, Animation],
        props: {},
        data() {
            return {
                result: null,
                loading: false,
                loadingMonth: false,
                loadingDays: true,
                pagination: {},
                firstLoad: true,
                form: {},
                month: null,
                activeMonth: null,
                activeYear: null,
                activeday: null,
                days: null,
                activeFilterSite: "",
            };
        },
        computed:{
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            formSubmit(noScroll) {
                this.loading = true;
                this.result = null;

                if (!this.firstLoad && !noScroll) {
                    Scrolling.scrollTo(".wrap-results", "easeOutCubic", 600, 200);
                }

                this.ajax("agenda", "getEvents", {
                    form: {
                        year: this.activeYear,
                        month: this.activeMonth,
                        day: this.activeday
                    }
                }).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.firstLoad = false

                    } else {
                        console.log("error");
                    }
                });


            },
            filtreSite(site) {
                this.activeFilterSite = site
            },
            getMonth() {
                this.month = null;
                this.loadingMonth = true
                this.ajax("agenda", "getMonth").always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loadingMonth = false
                        this.month = data.result;


                    } else {
                        console.log("error");
                    }
                });


            },
            getDaysDebounce: debounce(function () {
                return this.getDays()
            }, 600),
            getDays(firstinit) {
                if (!firstinit) {
                    this.result = null
                }
                this.days = null;
                this.loadingDays = true

                this.ajax("agenda", "getDays", {
                    form: {
                        year: this.activeYear,
                        month: this.activeMonth
                    }
                }).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loadingDays = false
                        this.days = data.result;
                        if (!firstinit) {
                            this.getFirstEvent()
                        }

                    } else {
                        console.log("error");
                    }
                });

            },
            changeMonth(item, mobile = false) {

                this.loadingDays = true
                if (!mobile){
                    this.activeMonth = item.number
                }
                this.activeday = null
                this.getDays()
            },
            removeYear() {
                this.activeYear = this.activeYear - 1
                this.activeMonth = 1
                this.getDaysDebounce()
            },
            addYear() {
                this.activeYear = this.activeYear + 1
                this.activeMonth = 1
                this.getDaysDebounce()
            },
            dayClasses(item) {
                let $outputClasses = ""

                if (item.number === this.activeday) {
                    $outputClasses += " active"
                }

                if (this.activeFilterSite === "rnn") {
                    return $outputClasses += item.site === "rnn" ? " rnn" : ""
                }

                if (this.activeFilterSite === "taaf") {
                    return $outputClasses += item.site === "taaf" ? " taaf" : ""
                }

                return $outputClasses += item.site ? " " + item.site : ""

            },
            selectDay(item) {
                if (item.site === undefined || item.site === "") {
                    return
                }
                this.activeday = item.number
                this.formSubmit()
            },
            getFirstGlobalEvent() {
                this.loading = true;
                this.result = null;

                this.ajax("agenda", "getNextEvents").always((data) => {

                    if (data.result === null) {
                        this.loading = false
                        this.getDays()
                        return
                    }

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.firstLoad = false

                        // mis à jour des dates
                        this.activeYear = data.calendar.year
                        this.activeMonth = data.calendar.month
                        this.activeday = data.calendar.day

                        this.getDays(true)


                    } else {
                        console.log("error");
                    }
                });

            },
            getFirstEvent() {
                let futurEvents = []

                for (var i = 0; i < this.days.length; i++) {

                    if (this.days[i].site !== undefined && this.days[i].site !== "") {
                        futurEvents.push(this.days[i])
                    }
                }

                if (futurEvents[0] !== undefined) {
                    this.activeday = futurEvents[0].number
                    this.formSubmit(true)
                }

            },
            initCalendar() {
                var today = new Date();
                this.activeYear = today.getFullYear()
                this.activeMonth = today.getMonth()+1
                this.activeday = today.getDate()

                this.getMonth()
                this.getFirstGlobalEvent()
            },
        },
        mounted() {
            this.initCalendar()
        },
        destroyed() {
        }
    };
</script>
